import React, { useState, useEffect } from 'react';
import {
  Grid,
  Button,
  TextField,
  CircularProgress,
  Typography
} from '@material-ui/core';

import CourseWork from '../../models/CourseWork';
import StudentSubmission from '../../models/StudentSubmission';
import { useDialog } from '../../context/Dialog';
import utils from '../../libs/utils';

export interface GradeInputProps {
  courseWork: CourseWork
  submission: StudentSubmission
}

const GradeInput = (props: GradeInputProps) => {
  const { courseWork, submission } = props;
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [isEnterMode, setIsEnterMode] = useState<boolean>(false);
  const [grade, setGrade] = useState<number | null>(null);
  const dialog = useDialog();

  const currentGrade = submission.getGrade();
  const isEmptyGrade: boolean = currentGrade === null;

  const saveGrade = async () => {
    try {
      setIsSaving(true);
      await submission.setAssignedGrade(grade);
      setIsEnterMode(false);
    }
    catch (e) {
      await dialog.alert(utils.getRequestErrorMessage(e), {
        title: 'Set Grade Error'
      });
    }
    finally {
      setIsSaving(false);
    }
  };

  useEffect(() => {
    setGrade(isEmptyGrade ? null : Number(submission.getGrade()));
  }, [submission, isEnterMode]);

  if(isEnterMode) return (
    <form className="d-inline-block" onSubmit={saveGrade}>
      <Grid container alignItems="center" spacing={1}>
        <Grid item>
          <TextField
            label="Grade"
            type="number"
            variant="outlined"
            disabled={isSaving}
            size="small"
            className="align-middle"
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{
              min: 0,
              max: courseWork.maxPoints,
              step: 0.01
            }}
            value={grade === null ? '' : grade}
            onChange={e => setGrade(e.target.value ? Number(e.target.value) : null)}
          />
        </Grid>

        {(() => {
          if (isSaving)
            return (
              <Grid item>
                <CircularProgress color="primary" size={24} />
              </Grid>
            );

          return (
            <>
              <Grid item>
                <Button type="submit"
                        variant="outlined"
                        size="small"
                        className="align-middle"
                        color="primary">
                  Save Grade
                </Button>
              </Grid>
              <Grid item>
                <Button type="button"
                        variant="outlined"
                        size="small"
                        onClick={() => setIsEnterMode(false)}
                        className="align-middle">
                  Cancel
                </Button>
              </Grid>
            </>
          );
        })()}
      </Grid>
    </form>
  );

  return (
    <Grid container spacing={1} alignItems="center">
      {!isEmptyGrade && (
        <Grid item>
          <Typography>{currentGrade}/<b>{courseWork.maxPoints}</b></Typography>
        </Grid>
      )}
      <Grid item>
        <Button type="button"
                variant="outlined"
                size="small"
                onClick={() => setIsEnterMode(!isEnterMode)}
                color="primary">
          {isEmptyGrade ? 'Enter' : 'Edit'} Grade
        </Button>
      </Grid>
    </Grid>
  );
};

export default GradeInput;
